const list = [
  {
    id: 1,
    name: '网关',
    type: '智能联接',
    imageSrc: 'image/product/product-gw.png',
    desc: '数据传输、协议转换、安全防护、设备管' +
      '理，实现对网络流量的实时监控、威胁自动阻' +
      '断，状态可视化配置',
  },
  {
    id: 2,
    name: '交换机',
    type: '智能联接',
    imageSrc: 'image/product/product-sw.png',
    desc:'数据交换、流量监控、环路预防、配置管' +
      '理，实现对网络数据包的实时转发、异常自动' +
      '检测，拓扑可视化操作',
  },
  {
    id: 3,
    name: 'AP',
    type: '智能联接',
    imageSrc: 'image/product/product-ap.png',
    desc: '无线覆盖、连接稳定性、数据传输、安全' +
      '管理，实现对无线设备的实时连接、性能自动' +
      '优化，状态可视化监控',
  },
  {
    id: 4,
    name: 'OLT',
    type: '智能联接',
    imageSrc: 'image/product/product-olt.png',
    desc: '光纤接入、信号转换、带宽管理、服务监' +
      '测，实现对光网络用户的实时连接、故障自动' +
      '诊断，状态可视化运维',
  },
  {
    id: 5,
    name: 'ODN',
    type: '智能联接',
    imageSrc: 'image/product/product-odn.png',
    desc: '信号传输、分支分配、无源设计、网络构' +
      '建，实现对光信号的高效分发和管理，确保OL' +
      'T与ONU之间的稳定通信',
  },
  {
    id: 6,
    name: 'MDU',
    type: '智能联接',
    imageSrc: 'image/product/product-mdu.png',
    desc: '集中管理、带宽共享、网络优化、光纤接' +
      '入，实现对多住户网络的高效分配、数据稳定' +
      '传输，设备运行可视化监控',
  },
  {
    id: 7,
    name: '光AP',
    type: '智能联接',
    imageSrc: 'image/product/product-gap.png',
    desc: '光纤接入、无线覆盖、性能稳定、易扩展，' +
      '实现对光纤信号的高效转换和无线网络的广泛' +
      '覆盖，设备运行可视化管理',
  },
  {
    id: 8,
    name: '计费认证系统',
    type: '运维管理',
    imageSrc: 'image/product/product-jfrz.png',
    desc: '身份验证、安全保障、费用计算、数据记录，对用户实现实时认证、使用情况自动计费，账单可视化展示',
  },
  {
    id: 9,
    name: '网管系统',
    type: '运维管理',
    imageSrc: 'image/product/product-wgxt.png',
    desc:'实时监控、故障预警、配置管理、性能分' +
      '析，对网络设备和流量实现全面监视、事件自' +
      '动告警，通过可视化界面展示网络状态',
  },
  {
    id: 10,
    name: '运营中台',
    type: '高阶辅助',
    imageSrc: 'image/product/product-yyzt.png',
    desc: '综合协同、效率优化、决策辅助、分析预' +
      '测，对业务流程实时监控、绩效自动评估，数' +
      '据可视化展示',
  },
  {
    id: 11,
    name: '运维工单',
    type: '高阶辅助',
    imageSrc: 'image/product/yygd.png',
    desc:'故障响应、任务调度、流程追踪、记录归' +
      '档，实现对维护任务的即时派发、进度自动更' +
      '新，操作可视化管理',
  },
  {
    id: 10,
    name: '客服系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-kfxt.png',
    desc: '需求捕捉、问题解析、服务导向、交互记' +
      '录，实现对客户请求的即时响应、问题自动分' +
      '类，服务过程可视化监控',
  },
  {
    id: 11,
    name: '审计系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-sjxt.png',
    desc:'合规检查、风险识别、报告生成、数据留' +
      '存，实现对操作和交易的实时审查、异常自动' +
      '标记，审计结果可视化呈现',
  },
  {
    id: 12,
    name: '进销存系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-jxc.png',
    desc: '库存监控、流程优化、数据分析、记录追' +
      '溯，实现对物品流转的实时跟踪、库存异常自' +
      '动提醒，数据可视化管理',
  },
  {
    id: 13,
    name: 'CRM系统',
    type: '高阶辅助',
    imageSrc: 'image/product/product-crm.png',
    desc:'客户洞察、关系维护、销售自动化、数据分析，实现对客户互动的实时跟踪、商机自动捕捉，数据可视化分析',
  },
  {
    id: 14,
    name: '上网管控',
    type: '高阶辅助',
    imageSrc: 'image/product/product-swgk.png',
    desc: '访问控制、内容过滤、行为监控、安全报' +
      '告，实现对上网流量的实时管理、违规行为自' +
      '动拦截，统计报告可视化呈现'
  },
  {
    id: 15,
    name: '宿舍水电控设备',
    type: '智慧物联',
    imageSrc: 'image/product/product-shsd.png',
    desc: '访问控制、内容过滤、行为监控、安全报' +
      '告，实现对上网流量的实时管理、违规行为自' +
      '动拦截，统计报告可视化呈现'
  },
  {
    id: 16,
    name: '智能饮用热水设备',
    type: '智慧物联',
    imageSrc: 'image/product/product-znyy.png',
    desc: '访问控制、内容过滤、行为监控、安全报' +
      '告，实现对上网流量的实时管理、违规行为自' +
      '动拦截，统计报告可视化呈现'
  },
  {
    id: 17,
    name: '通道闸机',
    type: '智慧物联',
    imageSrc: 'image/product/product-tdzj.png',
    desc: '出入控制、安全监测、流量统计、数据记' +
      '录，实现对人员进出的实时管理、非法入侵自' +
      '动报警，访问数据可视化分析'
  },
  {
    id: 18,
    name: '人脸门禁机',
    type: '智慧物联',
    imageSrc: 'image/product/product-rlmj.png',
    desc: '访问控制、内容过滤、行为监控、安全报' +
      '告，实现对上网流量的实时管理、违规行为自' +
      '动拦截，统计报告可视化呈现'
  },
  {
    id: 19,
    name: '三刷智能消费机',
    type: '智慧物联',
    imageSrc: 'image/product/product-shzn.png',
    desc: '支付便捷、消费记录、数据同步、财务报' +
      '表，实现对交易的即时处理、账目自动更新，' +
      '消费数据可视化统计',
  },
  {
    id: 20,
    name: '智能校园视频话机',
    type: '智慧物联',
    imageSrc: 'image/product/product-zzxy.png',
    desc: '通信融合、安全监控、互动教育、信息公' +
      '告，实现校园内部及远程通信的即时连接、紧' +
      '急情况自动报警，交互界面可视化操作',
  },
  {
    id: 21,
    name: '智能电子学生证',
    type: '智慧物联',
    imageSrc: 'image/product/product-zndj.png',
    desc: '身份验证、定位追踪、紧急求助、支付便' +
      '捷，实现对学生身份和安全的实时管理、异常' +
      '情况自动通知，使用状态可视化查询',
  },
  {
    id: 22,
    name: '智能电子班牌',
    type: '智慧物联',
    imageSrc: 'image/product/product-dzbp.png',
    desc: '信息发布、课程管理、校园互动、安全显' +
      '示，实现对教学日程的实时更新、紧急通知自' +
      '动推送，内容展示可视化操作',
  },
  {
    id: 23,
    name: 'AI防欺凌警报设备',
    type: '智慧物联',
    imageSrc: 'image/product/product-qlbj.png',
    desc: '行为分析、风险预警、实时干预、事件记' +
      '录，实现对校园欺凌行为的智能识别、潜在危' +
      '险自动提醒，处理过程可视化管理',
  },
  {
    id: 24,
    name: '校园安全系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-xyaqxt.png',
    desc: '综合监控、紧急响应、访客管理、数据分' +
      '析，实现对校园安全的全方位实时保护、潜在' +
      '风险自动报警，安全状况可视化监控',
  },
  {
    id: 25,
    name: '校园生活系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-xysh.png',
    desc: '服务集成、便捷支付、健康监测、互动交' +
      '流，实现对校园生活的全面支持、异常情况自' +
      '动反馈，生活服务可视化管理',
  },
  {
    id: 26,
    name: '教务总务系统',
    type: '智慧应用',
    imageSrc: 'image/product/product-jwzw.png',
    desc: '课程调度、资源分配、维护管理、效能分' +
      '析，实现对学校日常运行的高效协调、问题即' +
      '时响应，运维状态可视化监控',
  },


]

export default list



// WEBPACK FOOTER //
// ./src/pages/product/productsData.js